import Cta from "components/general/cta";
import Hero from "components/services/hero";
import SectionOne from "components/services/sectionOne";
import SectionTwo from "components/services/sectionTwo";
import ServicesOne from "components/services/servicesOne";
import Head from "next/head";
import styled from "styled-components";

const StyledWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const Services = () => {
  return (
    <>
      <Head>
        <title>Redact Private Bulk Deletion - All 30 Services</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Bulk delete from the most popular social media and direct messaging services. See all 30 plus services here. Download Redact to mass delete your content."
        />
        <meta name="keywords" content="redact mass delete privacy free services" />

        <meta property="og:title" content="Redact - Services that we support" />
        <meta
          property="og:description"
          content="Bulk delete from the most popular social media and direct messaging services. See all 30 plus services here. Download Redact to mass delete your content."
        />

        <meta property="og:url" content="https://www.redact.dev/services" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <StyledWrapper>
        <Hero />
        <ServicesOne />
        <SectionOne />
        <SectionTwo />
        <Cta />
      </StyledWrapper>
    </>
  );
};

export default Services;
